/**
 * Rotas estaticas do template.
 *
 * Mantenha aqui apenas o que precisa de logica especifica (login, logout,
 * dashboard padrao). Rotas dinamicas convencionadas a partir de
 * `views/app/**` sao registradas automaticamente em `FullRoutes.js`.
 */

import store from '@/state/store';
import axios from 'axios';

export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/account/login.vue'),
    meta: {
      title: 'Login',
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'default' });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/',
    name: 'default',
    meta: { title: 'Dashboard', authRequired: true },
    component: () => import('../views/app/dashboard/index.vue'),
    //component: () => import('../views/app/atendimento/index.vue'),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      title: 'Logout',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // Limpa o estado local e redireciona IMEDIATAMENTE. A chamada ao backend
        // é best-effort e NÃO pode bloquear a navegação: antes o `await` sem
        // timeout ficava pendurado se a requisição travasse, o `next()` nunca era
        // chamado e o "Sair" parecia não fazer nada. Agora o logout do backend
        // (que limpa os cookies httpOnly) roda em segundo plano, com timeout de
        // guarda; o redirect acontece de qualquer jeito.
        axios.post('/auth/logout', {}, { withCredentials: true, timeout: 8000 })
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.warn('Falha ao deslogar no backend:', e?.message);
          });

        const username = localStorage.getItem('username');
        localStorage.clear();
        sessionStorage.clear();
        if (username) localStorage.setItem('username', username);
        store.dispatch('auth/clearCurrentUser');
        next({ path: '/login' });
      },
    },
    component: () => import('../views/auth/logout/basic.vue'),
  },
];
